import { Banner } from "@lazarentertainment/web-design-system/components/banner"
import { DiscountSolid } from "@lazarentertainment/web-design-system/components/iconSolid"
import { FormattedMessage } from "react-intl"

export type DiscountCodeNoticeProps = {
  code: string
}

export const DiscountCodeNotice = ({ code }: DiscountCodeNoticeProps) => {
  return (
    <Banner
      data-variant="neutral"
      icon={DiscountSolid}
      bannerTitle={
        <FormattedMessage
          id="commerce.multiProductSelection.discount"
          defaultMessage={`Discount "{discountCode}" will be applied at checkout!`}
          values={{
            discountCode: code,
          }}
        />
      }
    />
  )
}
